export default class StringHelper {
  static toCamelCase(string: string) {
    return string.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
  }

  static isHex(value: string): boolean {
    return /^[0-9a-fA-F]+$/.test(value);
  }
}
